import { UntypedFormGroup } from '@angular/forms';

import {
  setDaysCorrectOrder,
  getOtherSchedulesWorkHours,
  getCurrentScheduleHours,
  scheduleIsInsideOtherSchedule,
} from './functions';
import { ISchedule } from './models';

export function scheduleValidator(schedules: ISchedule[]) {
  return (formGroup: UntypedFormGroup) => {
    if (!schedules.length) {
      return null;
    }

    const defaultSchedule = setDaysCorrectOrder(schedules.find(schedule => schedule.default));
    const currentSchedule = setDaysCorrectOrder(formGroup.value);
    const isDefaultSchedule = defaultSchedule._id === currentSchedule._id;
    const additionalSchedules = schedules
      .filter(schedule => schedule._id !== defaultSchedule._id)
      .map(schedule => setDaysCorrectOrder(schedule));

    let validation = null;
    const currentSchHours = getCurrentScheduleHours(currentSchedule);
    const otherSchedulesHours = additionalSchedules.map(schedule => getOtherSchedulesWorkHours(schedule));

    if (isDefaultSchedule) {
      const invalidSchedules = [];

      otherSchedulesHours.forEach((schedule, i) => {
        const isValid = scheduleIsInsideOtherSchedule(currentSchHours, schedule);

        if (!isValid) {
          invalidSchedules.push(i + 1);
        }
      });

      validation = invalidSchedules.length > 0
        ? {validDefaultSchedule: true, indices: invalidSchedules}
        : null;
    } else {
      const defaultScheduleHours = getOtherSchedulesWorkHours(defaultSchedule);
      const isCurrentIsInsideDefaultSchedule = scheduleIsInsideOtherSchedule(defaultScheduleHours, currentSchHours);

      validation = isCurrentIsInsideDefaultSchedule
        ? null
        : {validSchedule: true};
    }

    return validation;
  };
}
